const Abbreviations = {
  PRICE: "price",
  CLOTHING: "clothing",
  ACCESSORIES: "accessories",
  TOYS: "toys",
  ELECTRONICS: "electronics",
  PUNISHER: "punisher",
  DAREDEVIL: "daredevil",
  VENOM: "venom",
  DEADPOOL: "deadpool",
  LOKI: "loki",
  RATING: "rating",
  DISCOUNT: "discount",
  HIGHTOLOW: "highToLow",
  LOWTOHIGH: "lowToHigh",
  CLEARFILTER: "clearFilter",
  ADD_TO_CART: "addToCart",
  REMOVE_FROM_CART: "removerFromCart",
  UPDATE_QUANTITY: "updateQuantity",
  ADD_TO_WISHLIST: "addToWishlist",
  REMOVE_FROM_WISHLIST: "removeFromWishlist",
  WISHLIST_INITIAL: "wishlistInitial",
};
export { Abbreviations };
